import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { toast } from "react-toastify";
import SelectField from "../ui/SelectField";

const RazasForm = ({ especie, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    raza: "",
    especie: "",
  });
  const [especies, setEspecies] = useState([]);

  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL + "/util";

  // 🔹 Cargar especies
  const fetchEspecies = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/especies`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEspecies(res.data);
    } catch (error) {
      console.error("Error al cargar especies:", error);
      toast.error("No se pudieron cargar las especies");
    }
  }, [API_URL, token]);

  useEffect(() => {
    fetchEspecies();
  }, [fetchEspecies]);

  // 🔹 Cargar datos si se edita
  useEffect(() => {
    if (especie) {
      setFormData({
        raza: especie.raza || "",
        especie: especie.especie || "",
      });
    }
  }, [especie]);

  // 🔹 Manejar cambio de campos
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // 🔹 Enviar al backend
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.raza.trim() || !formData.especie.trim()) {
      toast.error("Debe ingresar la raza y seleccionar la especie");
      return;
    }

    onSave({
      raza: formData.raza,
      especie: formData.especie,
    });
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                {especie ? "Editar raza" : "Nueva raza"}
              </h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-sm font-medium">Raza *</label>
                <input
                  type="text"
                  name="raza"
                  value={formData.raza}
                  onChange={handleChange}
                  placeholder="Ej: Labrador"
                  className="w-full border rounded-lg p-2"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">Especie *</label>
                <SelectField
                  name="especie"
                  value={formData.especie}
                  onChange={handleChange}
                  placeholder="Seleccionar especie..."
                  options={especies}
                  valueKey="detalle"
                  displayFn={(esp) => esp.detalle}
                  required
                />
              </div>

              <div className="flex justify-end space-x-2 pt-4">
                <Button variant="outline" onClick={onClose} type="button">
                  Cancelar
                </Button>
                <Button type="submit">
                  {especie ? "Actualizar" : "Crear"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RazasForm;
